import * as Sentry from '@sentry/react';

const SentryConfig = () => {
    Sentry.init({
        dsn: process.env.REACT_APP_SENTRY_DSN || '',
        integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        tracesSampleRate: process.env.REACT_APP_SENTRY_ENVIRONMENT === 'production' ? 1.0 : 0.7,

        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: process.env.REACT_APP_SENTRY_ENVIRONMENT === 'production' ? 1.0 : 0.7,
        environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || 'development',
        enabled: ['development', 'production'].includes(process.env.REACT_APP_SENTRY_ENVIRONMENT!),
    });
};

export default SentryConfig;
